import { WHY_DUBAI } from "../data/site";
import { useReveal } from "../hooks/useReveal";

export const WhyDubai = () => {
  const ref = useReveal();
  return (
    <section
      id="why-dubai"
      data-testid="why-dubai-section"
      className="relative py-28 md:py-36 px-6 md:px-12 overflow-hidden"
    >
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[800px] rounded-full bg-[#c5a059]/5 blur-3xl pointer-events-none" />
      <div className="max-w-7xl mx-auto relative">
        <div ref={ref} className="reveal max-w-2xl mb-20">
          <div className="text-[10px] tracking-[0.5em] text-[#c5a059] uppercase mb-6">
            01 · The Opportunity
          </div>
          <h2 className="font-serif-display text-4xl md:text-6xl font-light leading-tight">
            Why investors choose <span className="italic gold-gradient">Dubai</span>
          </h2>
          <p className="text-white/60 mt-6 leading-relaxed max-w-xl">
            A tax-free haven with world-class infrastructure, sovereign-grade safety and one of
            the highest rental yields on the planet — Dubai is where global capital meets lifestyle.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-white/8 rounded-2xl overflow-hidden">
          {WHY_DUBAI.map((item, idx) => (
            <div
              key={item.title}
              className="bg-[#0a1128] p-10 md:p-12 group hover:bg-[#0e1736] transition-colors"
              data-testid={`why-dubai-card-${idx}`}
            >
              <div className="flex items-start justify-between gap-6">
                <div>
                  <div className="text-[10px] tracking-[0.4em] text-white/40 mb-3">
                    0{idx + 1}
                  </div>
                  <h3 className="font-serif-display text-2xl md:text-3xl mb-4">{item.title}</h3>
                  <p className="text-white/60 text-sm leading-relaxed max-w-md">
                    {item.description}
                  </p>
                </div>
                <div className="text-right shrink-0">
                  <div className="font-serif-display text-4xl md:text-5xl text-[#c5a059] leading-none">
                    {item.stat}
                  </div>
                  <div className="text-[9px] tracking-[0.3em] text-white/40 mt-2 uppercase">
                    {item.statLabel}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
